import {useEffect, useState} from 'react';
import {useFlags} from 'launchdarkly-react-client-sdk';

import Config from '../../config';

import {useRequest} from 'helpers/customHooks';

const ldEnabled = Config.flagProvider === 'launchDarkly';

export default () => {
  const ldFlags = useFlags();
  const portalSettingsRequest = useRequest(
    {url: '/settings'},
    {autoload: !ldEnabled},
  );
  const [portalSettings, setPortalSettings] = useState(null);

  useEffect(
    () => {
      if (portalSettingsRequest.data) {
        const settingsObj = {};
        portalSettingsRequest.data.forEach(item => {
          settingsObj[item.name] = item;
        });
        setPortalSettings(settingsObj);
      }
    },
    [portalSettingsRequest.data],
  );

  const getPS = key =>
    portalSettings && portalSettings[key]
      ? portalSettings[key].valueAsBool || portalSettings[key].value === 'false'
        ? portalSettings[key].valueAsBool
        : portalSettings[key].value
      : null;

  if (ldEnabled) {
    return {
      leadBookingOptInTri: ldFlags.leadBookingOptInTri,
      leadBookingAddon: ldFlags.leadBookingAddon,
      reactInvoiceEstimateEdit: ldFlags.invoiceEstimateEdit,
      reactInvoiceEstimateLists: ldFlags.invoiceEstimateList,
    };
  }

  return {
    leadBookingOptInTri: false,
    leadBookingAddon: false,
    reactInvoiceEstimateEdit: getPS('ReactEstimateInvoiceEdit'),
    reactInvoiceEstimateLists: getPS('ReactEstimateInvoiceLists') !== 'off',
  };
};



// WEBPACK FOOTER //
// ./src/helpers/customHooks/useFlags.js